import AttentionTrait from './AttentionTrait';
export default AttentionTrait;
